import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../routes";

export function AnalyticsComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="px-5 py-10 max-w-[520px] mx-auto flex flex-col items-center gap-7">
      <div className="w-[72px] h-[72px] rounded-[18px] bg-accent/[0.07] border border-accent/20 flex items-center justify-center">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <rect x="3" y="20" width="5" height="9" rx="1.5" className="fill-accent/25 stroke-accent" strokeWidth="1" />
          <rect x="10" y="14" width="5" height="15" rx="1.5" className="fill-accent/[0.18] stroke-accent" strokeWidth="1" />
          <rect x="17" y="8" width="5" height="21" rx="1.5" className="fill-accent/[0.12] stroke-accent" strokeWidth="1" />
          <rect x="24" y="4" width="5" height="25" rx="1.5" className="fill-accent/[0.07] stroke-accent/40" strokeWidth="1" strokeDasharray="3 2" />
        </svg>
      </div>
      <div className="text-center max-w-[380px]">
        <div className="text-lg font-light text-foreground mb-2.5">Dashboard analytics disponible</div>
        <div className="text-base text-secondary leading-[1.8] italic">Consultez l'activité des liens partagés, des ouvertures de carte et des intentions de commande sur une page dédiée.</div>
      </div>
      <button
        type="button"
        onClick={() => navigate(ROUTES.DASHBOARD)}
        className="min-h-[44px] rounded-[14px] border border-accent/20 bg-accent px-5 text-[14px] font-semibold text-[#FFF6EE] shadow-[0_10px_24px_rgba(217,102,60,0.2)]"
      >
        Ouvrir le dashboard
      </button>
    </div>
  );
}
